
const logoutQuestions = [
  {
    type: 'confirm',
    name: 'logout',
    message: "You're about to logout. Confirm?",
    default: false,
  },
]


export default {
  logoutQuestions,
}
